import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {User} from "../../models/user.model";
import {VetClinicPetSpecies} from "../../models/vet-clinic-pet-species.model";
import {Client} from "../../models/client.model";
import {Subscription} from "rxjs";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, Validators} from "@angular/forms";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {VetClinicPetSpeciesService} from "../../providers/vet-clinic-pet-species.service";
import {ClientsService} from "../../providers/clients.service";
import {ItemFinderComponent} from "../item-finder/item-finder.component";
import {WellnessPlan} from "../../models/wellness-plan.model";
import {WellnessPlanService} from "../../providers/wellness-plan.service";
import {VetClinic, VImage} from "../../models/vet-clinic.model";
import {CarePlanServicesService} from "../../providers/care-plan-services.service";
import {CarePlanService} from "../../models/care-plan-service.model";
import {WellnessPlanItem} from "../../models/wellness-plan-item.model";
import {WellnessPlanVetineoVisitTypeBundle} from "../../models/wellness-plan-vetineo-visit-type-bundle.model";
import {VetineoVisitTypeBundle} from "../../models/vetineo-visit-type-bundle.model";
import {VetineoVisitTypeBundleService} from "../../providers/vetineo-visit-type-bundle.service";
import {CarePlanServiceGroupType} from "../../models/care-plan-service-group-type.model";
import {CdkDragDrop} from "@angular/cdk/drag-drop";
import {CarePlanFaq} from "../../models/CarePlanFaq";

@Component({
  selector: 'app-edit-wellness-plan',
  templateUrl: './edit-wellness-plan.component.html',
  styleUrls: ['./edit-wellness-plan.component.scss'],
})
export class EditWellnessPlanComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input() wellnessPlan: WellnessPlan;
  @Input() csrfToken: string;

  @Output() objectEditedEmitter = new EventEmitter<WellnessPlan>();
  @Output() objectAddedEmitter = new EventEmitter<WellnessPlan>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();
  @Output() errorEmitter = new EventEmitter<string>();

  hasUnsavedChanges: boolean = false;
  isAdmin: boolean;
  isGeneralAdmin: boolean;
  loggedUser: User;

  isBusy: boolean;
  petSpecies: VetClinicPetSpecies[] = [];

  private isClientAdmin: boolean;
  isGeneralClientAdmin: boolean;
  clientSelected: Client;
  private subscriptions: Subscription = new Subscription();
  species: VetClinicPetSpecies;
  vetcodes: number[] = [];
  clinics: VetClinic[];
  clinicSub: Subscription;
  carePlanServices: CarePlanService[];
  wellnessPlanItems: WellnessPlanItem[] = [];
  wellnessPlanServices: WellnessPlanItem[] = [];
  availableQuantity: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  minAge: number = 0;
  maxAge: number = 0;
  wellnessPlanVetineoVisitTypeBundles: WellnessPlanVetineoVisitTypeBundle[] = [];
  vetineoVisitTypeBundles: VetineoVisitTypeBundle[] = [];
  serviceTypesForClient: CarePlanServiceGroupType[] = [];
  private firstImage: VImage;
  private secondImage: VImage;
  private thirdImage: VImage;
  faq: CarePlanFaq[] = [];
  discountDescription: string;
  discount: number;
  startNextMonth: boolean = true;

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private appStateService: AppStateService,
    private modalController: ModalController,
    private translateService: TranslateService,
    private vetClinicService: VetClinicService,
    private vetClinicPetSpeciesService: VetClinicPetSpeciesService,
    private wellnessPlanService: WellnessPlanService,
    private clientsService: ClientsService,
    private carePlanServicesService: CarePlanServicesService,
    private vetineoVisitTypeBundleService: VetineoVisitTypeBundleService
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {

    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    this.isAdmin = this.user.roles.split(';').filter(e => e === 'admin').length === 1;
    this.isGeneralClientAdmin = this.user.vClientId === null && this.user.vetcodeId === null && this.user.roles.split(';').filter(e => e === 'clients').length === 1;
    this.isGeneralAdmin = this.isAdmin && this.user.vClientId === null && this.user.vetcodeId === null;
    this.isClientAdmin = this.isAdmin && this.user.vClientId !== null && this.user.vetcodeId === null;

    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.vetClinicPetSpeciesService.getGlobalSpecies().subscribe(ps => {
      if (ps) {
        this.petSpecies = ps;
      }
      this.appStateService.updateIsBusySubject(false);
    }));

    if (this.action === 'ADD') {
      this.componentTitle = 'Dodaj nowy pakiet';
      this.actionBtnLabel = 'Dodaj nowy pakiet';
      this.actionQuestion = 'Na pewno chcesz dodać nowy pakiet?';
      this.actionSuccess = 'Nowy pakiet został dodany';
      this.actionError = 'Wystąpił błąd podczas dodawania pakietu'
      this.formGroup = this.formBuilder.group({
        name: ['', [Validators.required]],
        description: ['', [Validators.required]],
        welcomeText: ['', [Validators.required]],
        inProgressText: ['', [Validators.required]],
        completionText: ['', [Validators.required]],
        firstImageUUID: [''],
        secondImageUUID: [''],
        thirdImageUUID: [''],
        terms: ['']
      });

      if (this.user.vClientUUID) {
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.clientsService.getClientByUUID(this.user.vClientUUID).subscribe(client => {
          if (client) {
            this.clientSelected = client;
            this.fetchClinics(this.clientSelected.uuid);
            this.fetchServices(this.clientSelected.uuid);
            this.fetchBundles(this.clientSelected.uuid);
            this.registerSubscription(this.carePlanServicesService.getCarePlanServiceGroupTypes(this.clientSelected.uuid).subscribe(carePlanServiceGroupTypes => {
              if (carePlanServiceGroupTypes) {
                this.serviceTypesForClient = carePlanServiceGroupTypes;
              }
              this.appStateService.updateIsBusySubject(false);
            }, error => {
              this.appStateService.updateIsBusySubject(false);
            }));
          } else {
            this.appStateService.updateIsBusySubject(false);
          }
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        }));
      }

    } else {

      this.minAge = this.wellnessPlan.minAnimalAge;
      this.maxAge = this.wellnessPlan.maxAnimalAge;
      this.startNextMonth = this.wellnessPlan.startNextMonth;

      if (this.wellnessPlan.vClientId) {
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.clientsService.getClientById('' + this.wellnessPlan.vClientId).subscribe(client => {
          if (client) {
            this.clientSelected = client;
            this.vetcodes = this.wellnessPlan.vetClinics.map(e => e.vetcodeId);
            this.fetchClinics(this.clientSelected.uuid);
            this.fetchBundles(this.clientSelected.uuid);
            this.fetchServices(this.clientSelected.uuid);
            this.registerSubscription(this.carePlanServicesService.getCarePlanServiceGroupTypes(this.clientSelected.uuid).subscribe(carePlanServiceGroupTypes => {
              if (carePlanServiceGroupTypes) {
                this.serviceTypesForClient = carePlanServiceGroupTypes;
              }
              this.appStateService.updateIsBusySubject(false);
            }, error => {
              this.appStateService.updateIsBusySubject(false);
            }));
          }
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        }));

      }

      this.species = this.wellnessPlan.petSpecies;
      this.discount = this.wellnessPlan.discount;
      this.discountDescription = this.wellnessPlan.discountDescription;

      if (this.wellnessPlan.wellnessPlanItems) {
        this.wellnessPlanItems = this.wellnessPlan.wellnessPlanItems.filter(e => e.vetineoVisitTypeBundleUUID);
        this.wellnessPlanItems.sort((a,b) => {
          return a.orderIndex - b.orderIndex;
        });
        this.wellnessPlanServices = this.wellnessPlan.wellnessPlanItems.filter(e => !e.vetineoVisitTypeBundleUUID);
      } else {
        this.wellnessPlanItems = [];
        this.wellnessPlanServices = [];
      }

      if (this.wellnessPlan.wellnessPlanVetineoVisitTypeBundles) {
        this.wellnessPlanVetineoVisitTypeBundles = this.wellnessPlan.wellnessPlanVetineoVisitTypeBundles;
      } else {
        this.wellnessPlanVetineoVisitTypeBundles = [];
      }

      this.componentTitle = 'Edytuj pakiet';
      this.actionBtnLabel = 'Edytuj pakiet';
      this.actionQuestion = 'Na pewno chcesz edytować pakiet?';
      this.actionSuccess = 'Pakiet został zmieniony';
      this.actionError = 'Wystąpił błąd podczas edytowania pakietu';
      this.formGroup = this.formBuilder.group({
        name: [this.wellnessPlan.name, [Validators.required]],
        description: [this.wellnessPlan.description, [Validators.required]],
        welcomeText: [this.wellnessPlan.welcomeText, [Validators.required]],
        inProgressText: [this.wellnessPlan.inProgressText, [Validators.required]],
        completionText: [this.wellnessPlan.completionText, [Validators.required]],
        firstImageUUID: [this.wellnessPlan.firstImageUUID],
        secondImageUUID: [this.wellnessPlan.secondImageUUID],
        thirdImageUUID: [this.wellnessPlan.thirdImageUUID],
        terms: [this.wellnessPlan.terms]
      });

      if (this.wellnessPlan.faq) {
        this.faq = JSON.parse(this.wellnessPlan.faq);
      }

    }

    super.ngOnInit();
  }

  comparePets(o1, o2) {
    return o1 && o2 ? o1.uuid == o2.uuid : false;
  }

  addFaqSection() {
    this.faq.push({
      title: '',
      elements: []
    });
  }

  addFaqElement(sectionIndex: number) {
    this.faq[sectionIndex].elements.push({
      question: '',
      answer: ''
    });
  }

  removeFaqElement(sectionIndex: number, elementIndex: number) {
    this.faq[sectionIndex].elements.splice(elementIndex, 1);
  }

  removeFaqSection(index: number) {
    this.faq.splice(index, 1);
  }

  fetchClinics(uuid) {
    this.appStateService.updateIsBusySubject(true);
    this.clinicSub = this.vetClinicService.listClinicsForClient(uuid).subscribe(e => {
      if (e) {
        this.clinics = e;
        if (this.clinics.length === 1) {
          let vetcodeId = this.clinics[0].vetcodeId;
          this.vetcodes = [];
          this.vetcodes.push(vetcodeId);
        }
        this.appStateService.updateIsBusySubject(false);
      } else {
        this.appStateService.updateIsBusySubject(false);
      }
    });

  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
    }
    super.markUnsavedChanges();
  }

  changeStartNextMonthToggle($event) {
    this.startNextMonth = $event.detail.checked;
  }

  onAction() {
    if (this.formGroup.valid) {
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        let wellnessPlan: WellnessPlan = this.commonUtils.formGroupValuesToObject<WellnessPlan>(new WellnessPlan(), this.formGroup);

        let serviceMethod;

        this.wellnessPlan.vetClinics = this.vetcodes.map(e => this.clinics?.filter(s => s.vetcodeId == e)[0]);
        this.wellnessPlan.name = wellnessPlan.name;
        this.wellnessPlan.description = wellnessPlan.description;
        this.wellnessPlan.wellnessPlanItems = this.wellnessPlanItems;
        this.wellnessPlan.wellnessPlanItems.push(...this.wellnessPlanServices);
        this.wellnessPlan.minAnimalAge = this.minAge;
        this.wellnessPlan.maxAnimalAge = this.maxAge;
        this.wellnessPlan.terms = wellnessPlan.terms;
        this.wellnessPlan.inProgressText = wellnessPlan.inProgressText;

        this.wellnessPlan.discount = this.discount;
        this.wellnessPlan.discountDescription = this.discountDescription;

        this.wellnessPlan.startNextMonth = this.startNextMonth;

        if (this.faq) {
          this.wellnessPlan.faq = JSON.stringify(this.faq);
        }

        if (wellnessPlan.firstImageUUID && this.firstImage) {
          this.wellnessPlan.firstImageUUID = wellnessPlan.firstImageUUID;
        }

        if (wellnessPlan.secondImageUUID && this.secondImage) {
          this.wellnessPlan.secondImageUUID = wellnessPlan.secondImageUUID;
        }

        if (wellnessPlan.thirdImageUUID && this.thirdImage) {
          this.wellnessPlan.thirdImageUUID = wellnessPlan.thirdImageUUID;
        }

        this.wellnessPlan.welcomeText = wellnessPlan.welcomeText;
        this.wellnessPlan.completionText = wellnessPlan.completionText;

        if (this.clientSelected) {
          this.wellnessPlan.vClientId = this.clientSelected.id;
        } else {
          this.wellnessPlan.vClientId = Number.parseInt(this.user.vClientId);
        }

        if (this.species) {
          this.wellnessPlan.petSpecies = this.species;
        }

        this.wellnessPlan.wellnessPlanItems.forEach(e => {
          e.wellnessPlanItemFrequency = 'ANNUALLY';
          e.uuid = null;
          e.vetineoVisitTypeBundle = null;
        });

        if (this.action === 'EDIT') {
          serviceMethod = this.wellnessPlanService.updateWellnessPlan(this.wellnessPlan);
        } else {
          serviceMethod = this.wellnessPlanService.addWellnessPlan(this.wellnessPlan);
        }

        this.handleActionMethod(serviceMethod, this.objectAddedEmitter, this.objectEditedEmitter, this.errorEmitter);

      }, () => {
      });
    } else {
      this.commonUtils.presentAlertToast('Popraw błędy w formularzu');
    }
  }


  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected ? this.clientSelected.name : ''
      }
    });

    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.clientSelected = data.data;
        this.fetchServices(this.clientSelected.uuid);
        this.fetchClinics(this.clientSelected.uuid);
        this.fetchBundles(this.clientSelected.uuid);
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.carePlanServicesService.getCarePlanServiceGroupTypes(this.clientSelected.uuid).subscribe(carePlanServiceGroupTypes => {
          if (carePlanServiceGroupTypes) {
            this.serviceTypesForClient = carePlanServiceGroupTypes;
          }
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        }));
      }
    });

    return await modal.present();
  }


  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  onSelectClinic($event) {
    let vetcodes = $event.detail.value;
    this.vetcodes = vetcodes
  }

  private fetchServices(uuid) {
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.carePlanServicesService.getCarePlanServiceForClient(uuid).subscribe(e => {
      this.appStateService.updateIsBusySubject(false);
      if (e) {
        this.carePlanServices = e;
      } else {
        this.commonUtils.presentAlertToast('Brak zdrefiniowanych usług')
      }
    }, error => {
      this.appStateService.updateIsBusySubject(false);
      this.commonUtils.presentAlertToast('Brak zdrefiniowanych usług')
    }));
  }


  private fetchBundles(uuid) {
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.vetineoVisitTypeBundleService.getBundlesByClientUUID(uuid).subscribe(e => {
      this.appStateService.updateIsBusySubject(false);
      if (e && e.length > 0) {
        this.vetineoVisitTypeBundles = e;
      } else {
        this.commonUtils.presentAlertToast('Brak zdrefiniowanych typów wizyt')
      }
    }, error => {
      this.appStateService.updateIsBusySubject(false);
      this.commonUtils.presentAlertToast('Brak zdrefiniowanych typów wizyt')
    }));
  }


  getAvailableCarePlanServices(uuid) {
    return this.carePlanServices?.filter(carePlanService => carePlanService.uuid === uuid ||
      !this.wellnessPlanItems?.filter(e => e.carePlanServiceUUID === carePlanService.uuid)[0]);
  }

  removeWellnessPlanItem(idx: any) {
    if (this.wellnessPlanItems[idx] !== undefined) {
      this.commonUtils.presentYesNoActionSheet(`Na pewno chcesz usunąć tę wizytę?`, 'Tak', 'Nie', 'trash', 'close', () => {
        this.wellnessPlanItems.splice(idx, 1);
        // this.refreshServiceTypesAvailable();
        this.markUnsavedChanges();
      }, () => {
      });
    }
  }



  addNewWellnessPlanItem() {
    if (this.carePlanServices?.length === 0 || (this.carePlanServices?.filter(carePlanService =>
      !this.wellnessPlanItems?.filter(e => e.carePlanServiceUUID === carePlanService.uuid)[0]).length > 0)) {
      const wellnessPlanItem = new WellnessPlanItem();
      wellnessPlanItem.orderIndex = this.wellnessPlanItems.length;
      this.wellnessPlanItems.push(wellnessPlanItem);
    } else {
      this.commonUtils.presentAlertToast('Wszystkie usługi zostały już zdefiniowane')
    }
  }

  areValidWellnessPlanItems() {
    if (this.wellnessPlanItems) {
      return this.wellnessPlanItems?.filter(wellnessPlanItem => this.isNotValid(wellnessPlanItem)).length === 0;
    } else {
      return true;
    }
  }

  private isNotValid(wellnessPlanItem: WellnessPlanItem) {
    return !wellnessPlanItem.carePlanServiceUUID || !wellnessPlanItem.quantity || !wellnessPlanItem.typeUUID || !wellnessPlanItem.vetineoVisitTypeBundleUUID;
  }

  getBundleName(vetineVisitTypeBundle: any) {
    if (vetineVisitTypeBundle?.nameAdditionPL) {
      return vetineVisitTypeBundle.namePL + ' ' + vetineVisitTypeBundle.nameAdditionPL;
    } else {
      return vetineVisitTypeBundle?.namePL;
    }
  }

  getBundlesForCarePlan() {
    return this.vetineoVisitTypeBundles?.filter(e => e.isCarePlan);
  }

  drop($event: CdkDragDrop<any, any>) {

    this.wellnessPlanItems[$event.previousIndex].orderIndex = $event.currentIndex;
    this.wellnessPlanItems[$event.currentIndex].orderIndex = $event.previousIndex;
    this.wellnessPlanItems.sort((a,b) => {
      return a.orderIndex - b.orderIndex;
    });
  }

  getServiceNameFromPlanItem(wellnessPlanItem: WellnessPlanItem) {
    const service = this.carePlanServices?.filter(carePlanService => carePlanService.uuid === wellnessPlanItem.carePlanServiceUUID)[0];
    if (service) {
      return service.name;
    }
    return null;
  }

  addNewFaq() {
    if (!this.faq) {
      this.faq = [];
    }
    this.faq.push(new CarePlanFaq());
  }

  removeFaq(index: number) {
    this.faq.splice(index, 1);
  }


  test() {
    console.log(this.faq)
  }
}
